<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="operationType.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Бухгалтерские счета</label>
            <crm-accounting-account-multi-select
              [(selectedAccounts)]="operationType.accountingAccounts"
              [isError]="$any(errors?.accountingAccounts)"
              appendTo="body"></crm-accounting-account-multi-select>
            <small
              *ngIf="errors?.accountingAccounts"
              class="p-error">
              {{ errors.accountingAccounts | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Движение ДС</label>
            <crm-single-select
              [options]="types"
              [(selectedItem)]="operationType.type"
              dataKey="name"
              [isError]="!!errors?.type"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | operationTypeMoveTypeName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.type"
              class="p-error">
              {{ errors.type | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Тип заявки на платеж</label>
            <crm-single-select
              [options]="brsTaskKinds"
              [(selectedItem)]="operationType.brsTaskKind"
              dataKey="name"
              class="w-full {{ errors?.brsTaskKind ? 'ng-invalid ng-dirty' : '' }}"
              [styleClass]="errors?.brsTaskKind ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              [showClear]="true"
              (selectedItemChange)="changeTaskKind()"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-kind="item">
                {{ kind.value | taskKindName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.brsTaskKind"
              class="p-error">
              {{ errors.brsTaskKind | join }}
            </small>
          </div>

          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="operationType.ignoreInDocumentCompare"
              [binary]="true"
              inputId="ignoreInDocumentCompare"></p-checkbox>
            <label [for]="'ignoreInDocumentCompare'">Не учитывать в сверке оборотов</label>
          </div>

          <div
            *ngIf="(form$ | async)?.isShowDelete"
            class="field-checkbox mb-0">
            <p-checkbox
              [(ngModel)]="operationType.forUndistributed"
              [binary]="true"
              (ngModelChange)="setUndistributed()"
              inputId="forUndistributed"></p-checkbox>
            <label [for]="'forUndistributed'">Сделать группой по-умолчанию для нераспределенных видов операций</label>
          </div>

          <div
            *ngIf="operationType['deleted']"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удален"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.OPERATION_TYPE"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="operationTypeService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="saveOperationType()"></button>
      <div class="flex align-items-center gap-2">
        <button
          *ngIf="(form$ | async)?.isShowDelete && !operationType['deleted']"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteOperationType()"></button>
        <button
          *ngIf="(form$ | async)?.isShowDelete && operationType['deleted']"
          pButton
          icon="pi pi-undo"
          label="Восстановить"
          class="p-button-info p-button-text"
          (click)="restoreOperationType()"></button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
